<div class="d-flex flex-column gap-2">

	<common-date-time-field [field]="interviewDateTime()"></common-date-time-field>

	<common-button-row [center]="true">
		<button #dateTimeForm class="btn btn-standard" [disabled]="!dialogDataService.canRecruitVolunteers()">
			Save
		</button>
	</common-button-row>
</div>